
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveIntegrationCardAccountConnector"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountConnector"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"service"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remoteMeta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"syncStatus"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":180}};
    doc.loc.source = {"body":"# ActiveIntegrationCard/accountConnectorFragment.graphql\nfragment ActiveIntegrationCardAccountConnector on AccountConnector {\n  id\n  service\n  remoteMeta\n  accountId\n  syncStatus\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
